module.exports = __webpack_public_path__ + "img/b4eb292.jpeg";